import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import Storage from '@/amplify/storage';

export const isShowButtonLog = ({
    corporationDetail,
    projectInuseDetail,
    currentUserDetail,
    listMessageContent,
}) => {
    let userSetting = Utils.convertJSONDataToObject(currentUserDetail.userSetting);

    // filter message hidden
    let listContentMessageClone = listMessageContent?.filter(message => !message.isHidden);

    const adminMode = userSetting?.adminMode;
    if (listContentMessageClone.length < 1) {
        return false;
    }
    if (listContentMessageClone.length === 2 && listContentMessageClone[1]?.isLoadingMessage) {
        return false;
    }

    if (
        listContentMessageClone.length > 1 &&
        new Date(listContentMessageClone[0].dateTime) < new Date('2024-03-03')
    ) {
        return false;
    }

    if (corporationDetail?.rootFlag && adminMode === Constant.ADMIN_MODE.ON && Utils.isAdminUser(currentUserDetail)) {
        return true;
    }

    if (!Utils.isEmptyObject(projectInuseDetail)) {
        let projectSetting = Utils.convertJSONDataToObject(projectInuseDetail?.projectSetting);
        let chatAiSetting = projectSetting.chatAISetting;

        if (chatAiSetting?.isShowLogAiChat && !Utils.isB2CUser(currentUserDetail)) {
            return true;
        }
    }
    return false;
};

export const updateLogURL = async ({chatThreadId, setLogUrl, isMounted = false}) => {
    try {
        if (!chatThreadId) return;

        const url = await Storage.get(`log-chat-ai/${chatThreadId}.json`, { expires: 7200 });
        if (isMounted && url) {
            setLogUrl(url);
        }
    } catch (error) {
        console.error('Failed to get log URL:', error);
        if (!chatThreadId) return;
    }
};

export const openAiLogDetail = async (chatThreadId) => {
    try {
        if (!chatThreadId) return;

        const url = await Storage.get(`log-chat-ai/${chatThreadId}.json`, { expires: 7200 });
        window.open(url, '_blank', 'noopener,noreferrer');
    } catch (error) {
        console.log('openAiLogDetail error :', error);
    }
};
